import { configureStore } from '@reduxjs/toolkit'
import  ContrastReducer from './reducers/ContrastSlice'
import CalendarRangeReducer from './reducers/CalendarRangeSlice';
import SelectDropDownReducer from './reducers/SelectDropDownSlice';
import MonthFilterDropdown from './reducers/MonthFilterDropdown';
import LoginSessionReducer from './reducers/LoginSessionSlice'
import LogoutReducer from './reducers/LogoutSlice';
import ProjectCountDisplayReducer from './reducers/ProjectCountDisplayStatus';
import ProjectStatusOrderReducer from './reducers/ProjectStatusOrder';
import TaskTypeSelectedReducer from './reducers/TaskTypeSelected';
import PaginationReducer from './reducers/PaginationSlice';
import TasksOnSameDateReducer from './reducers/TasksOnSameDateSlice';
import FollowingReducer from './reducers/FollowingSlice';
import ProjectCreationStepReducer from './reducers/ProjectCreationStepSlice';
import CampaignCountDisplayOrderReducer from './reducers/CampaignCountDisplayOrder';
import CampaignCountDisplayStatusReducer from './reducers/CampaignCountDisplayStatus';
import CampaignStatusFilterReducer from './reducers/CampaignStatusFilterSlice';
import CampaignDeliveryStatusFilterReducer from './reducers/CampaignDeliveryStatusFilterSlice';
import CampaignTagFilterReducer from './reducers/CampaignTagFilterSlice';
import ProjectEditMessageReducer from './reducers/ProjectEditMessageSlice';
import ProjectFilterReducer from './reducers/ProjectFilterSlice';
import CampaignMemberFilterReducer from './reducers/CampaignMemberFilterSlice';
import CampaignSearchFilterReducer from './reducers/CampaignSearchFilterSlice';
import ProjectListSearchReducer from './reducers/ProjectListSearchSlice';
import ProjectFollowersReducer from './reducers/ProjectFollowersSlice';
import SelectedProjectWorkflowReducer from './reducers/SelectedProjectWorkflowSlice';
import CreateProjectDepartmentSelectReducer from './reducers/CreateProjectDepartmentSelectSlice';
import CreateProjectSourceLanguageReducer from './reducers/CreateProjectSourceLanguageSlice';
import CreateProjectTargetLanguageReducer from './reducers/CreateProjectTargetLanguageSlice';
import CreateProjectContentTypeReducer from './reducers/CreateProjectContentTypeSlice'; 
import CampaignRightModalIdReducer from './reducers/CampaignRightModalIdSlice';
import ProjectInfoSliceReducer from './reducers/ProjectInfoSlice';
import BidRequestSliceReducer from './reducers/BidRequestSlice';
import ProjectInfoValidationSliceReducer from './reducers/ProjectInfoValidationSlice';
import ProjectInfoConfigurationSliceReducer from './reducers/ProjectInfoConfigurationSlice';
import LanguageFilterReducer from './reducers/LanguageFilterSlice';
import InitializedProjectWorkflowsReducer from './reducers/InitializedProjectWorkflowsSlice';
import ProjectStatusReducer from './reducers/ProjectStatusSlice';
import SourceFilesReducer from './reducers/SourceFilesSlice';
import DocumentationReducer from './reducers/DocumentationSlice';
import CampaignFlagReducer from './reducers/CampaignFlagSlice';
import VendorSelectReducer from './reducers/VendorSelectSlice';
import campaignOwnerFilterReducer from './reducers/CamapignOwnerFilterSlice';
import campaignAlReducer from './reducers/CampaignAllSlice';
import projectMemberReducer from './reducers/ProjectMembersSlice';
import treeReducer from './reducers/TreeSlice';
import CreateProjectAssetTypeReducer from './reducers/CreateProjectAssetTypeSlice';
import OldTargetLanguageSlice from './reducers/OldTargetLanguageSlice';
import DynamicAssetReducer from './reducers/DynamicAssetSlice';
import CustomerBootstrapDataReducer from './reducers/CustomerBootstrapDataSlice';
import ReviewWorkFlowReducer from './reducers/ReviewWorkFlowSlice';
import ProjectRequestSourceDocumentReducer from './reducers/ProjectRequestSourceDocumentSlice';
import ProjectRequestReferenceDocumentReducer from './reducers/ProjectRequestReferenceDocumentSlice';
import storage from 'redux-persist/lib/storage';
//import storageSession from 'redux-persist/lib/storage/session'
import persistStore from 'redux-persist/es/persistStore';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import RightModelHideReducer from './reducers/RightModelStatus';
import RolePermissionReducer from './reducers/RolePermissionSlice';
import AsyncAssetUploadReducer  from './reducers/AsyncAssetUploadSlice';
import StripeReducer from './reducers/StripeSlice';
import PendingWorkflowReducer from './reducers/PendingWorkflowSlice';
import ProjectRequestIntegrationReducer from './reducers/ProjectRequestIntegrationSlice';
import TourReducer from './reducers/TourSlice';
import ProjectRequestReducer from './reducers/ProjectRequestListSlice';
import SystemAnnouncementReducer from './reducers/SystemAnnouncementSlice';
import ReportsReducer from './reducers/ReportsSlice';
import FinanceProjectFilterReducer from './reducers/FinanceProjectFilterSlice';

import thunk from 'redux-thunk';


const reducers = combineReducers({
  contrast : ContrastReducer,
  calendar_range : CalendarRangeReducer,
  select_dropdown : SelectDropDownReducer,
  select_month : MonthFilterDropdown,
  loginSession : LoginSessionReducer,
  logout_session : LogoutReducer,
  project_status_display : ProjectCountDisplayReducer,
  order_status : ProjectStatusOrderReducer,
  campaign_count_display_order : CampaignCountDisplayOrderReducer,
  campaign_status_display : CampaignCountDisplayStatusReducer,
  task_selected : TaskTypeSelectedReducer,
  paginate : PaginationReducer,
  tasks_same_date : TasksOnSameDateReducer,
  follow : FollowingReducer,
  project_creation_step: ProjectCreationStepReducer,
  campaign_status_filter : CampaignStatusFilterReducer,
  campaign_tag_filter : CampaignTagFilterReducer,
  campaign_delivery_status_filter : CampaignDeliveryStatusFilterReducer,
  project_filters : ProjectFilterReducer,
  campaign_member_only_filter : CampaignMemberFilterReducer,
  campaign_search_filter : CampaignSearchFilterReducer,
  project_list_search : ProjectListSearchReducer,
  project_followers : ProjectFollowersReducer,
  selected_project_workflow : SelectedProjectWorkflowReducer,
  select_department_for_project_creation : CreateProjectDepartmentSelectReducer,
  source_language_for_project_creation : CreateProjectSourceLanguageReducer,
  target_language_for_project_creation : CreateProjectTargetLanguageReducer,
  content_type_for_project_creation : CreateProjectContentTypeReducer,
  campaign_id : CampaignRightModalIdReducer,
  project_info : ProjectInfoSliceReducer,
  selected_language : LanguageFilterReducer,
  bid_request:BidRequestSliceReducer,
  project_info_configuration_slice:ProjectInfoConfigurationSliceReducer,
  project_info_validation_slice:ProjectInfoValidationSliceReducer,
  initialized_project_workflows: InitializedProjectWorkflowsReducer,
  project_status : ProjectStatusReducer,
  source_files : SourceFilesReducer,
  documentation_flag:DocumentationReducer,
  campaign_Flag:CampaignFlagReducer,
  vendor_select:VendorSelectReducer,
  campaign_owner_filter:campaignOwnerFilterReducer,
  campaign_all_filter:campaignAlReducer,
  members_list:projectMemberReducer,
  tree_structure : treeReducer,
  asset_type_for_project_creation : CreateProjectAssetTypeReducer,
  old_target_language:OldTargetLanguageSlice,
  dynamic_asset : DynamicAssetReducer, 
  customer_bootstrap_data : CustomerBootstrapDataReducer,
  edit_review_workflow : ReviewWorkFlowReducer,
  right_model_status:RightModelHideReducer,
  role_permission : RolePermissionReducer,
  project_edit_message_slice:ProjectEditMessageReducer,
  project_request_source_material : ProjectRequestSourceDocumentReducer,
  project_request_reference_material : ProjectRequestReferenceDocumentReducer,
  asset_upload_background: AsyncAssetUploadReducer,
  project_request_list:ProjectRequestReducer,
  stripe: StripeReducer,
  pending_workflow: PendingWorkflowReducer,
  project_request_integration: ProjectRequestIntegrationReducer,
  tour_steps:TourReducer,
  systemannouncement_popup:SystemAnnouncementReducer,
  reports:ReportsReducer,
  finance_project_filters:FinanceProjectFilterReducer

});
  
const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = (state, action) => {
  if (action.type === 'contrast/reduxLogout') {
    state = undefined;
    storage.removeItem('persist:root')
  }
  
  return reducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});





//export {rootReducer }

export default store;
